import React from 'react'
import src from '../assets/geomarker128.png'

import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import { 
	getCurrentPlace,
} from '../selectors'

const propTypes = {
  entityIsLoading: React.PropTypes.bool.isRequired,
  cameraIsFlying: React.PropTypes.bool.isRequired,
  selectedEntity: React.PropTypes.object,
}

class GeoMarkerClass extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    if ( ! this.props.entityIsLoading && ( ! this.props.selectedEntity || this.props.cameraIsFlying)) {
      return (
        <div className="GeoMarker">
          <img className="GeoMarker-image GeoMarker-image--hidden" src={src} />
        </div>
      )
    }

    return (
      <div className="GeoMarker">
        <img className="GeoMarker-image GeoMarker-image--visible" src={src} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

GeoMarkerClass.propTypes = propTypes

const GeoMarker = connect(
  mapStateToProps,
  mapDispatchToProps
)(GeoMarkerClass)

export default GeoMarker


// WEBPACK FOOTER //
// ./src/components/GeoMarker.js